import { createAction, props } from '@ngrx/store';

import { SearchResult } from '@core/api';
import { Extent } from '@shared/open-layers';

import { SearchCacheItem } from '../reducers/search.reducer';

export const search = createAction('[Search Bar] Trigger Search', props<{ phrase: string }>());

export const searchCompleted = createAction('[Search API] Search Completed', props<{ results: SearchCacheItem[] }>());

export const clear = createAction('[Search Bar] Clear Search Phrase');

export const zoomToResult = createAction('[Search] Zoom To Result', props<{ result: SearchResult; searchType: string }>());

export const searchBarClicked = createAction('[Search] Search Bar Clicked');

export const renderLocation = createAction('[Search] Render Location', props<{ location: GeoJSON.Feature[] | Extent }>());
